import Model, { attr, belongsTo } from "@ember-data/model";
import type FileAttachment from "parog-web/models/file-attachment";

export default class FileContent extends Model {
  @attr("string") declare data: string;
  @belongsTo("file-attachment", {
    async: false,
    inverse: "fileContent"
  })
  declare fileAttachment: FileAttachment;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "file-content": FileContent;
  }
}
